// Centralized data-testid registry
export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  container: "nav-container",
  logo: "nav-logo",
  linkServices: "nav-link-services",
  linkAbout: "nav-link-about",
  linkResults: "nav-link-results",
  linkBook: "nav-link-book",
  ctaBook: "nav-cta-book",
};

export const HERO = {
  section: "hero-section",
  title: "hero-title",
  subtitle: "hero-subtitle",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
  logo: "hero-logo",
};

export const ABOUT = {
  section: "about-section",
  heading: "about-heading",
};

export const SERVICES = {
  section: "services-section",
  heading: "services-heading",
  card: (i) => `service-card-${i}`,
};

export const RESULTS = {
  section: "results-section",
  stat: (key) => `stat-${key}`,
};

export const TRUSTED = {
  section: "trusted-section",
  heading: "trusted-heading",
  logo: (i) => `trusted-logo-${i}`,
};

export const BOOKING = {
  section: "booking-section",
  form: "booking-form",
  inputName: "booking-input-name",
  inputEmail: "booking-input-email",
  inputCompany: "booking-input-company",
  selectService: "booking-select-service",
  selectBudget: "booking-select-budget",
  inputMessage: "booking-input-message",
  submit: "booking-submit",
  success: "booking-success",
  error: "booking-error",
};

export const FOOTER = {
  container: "footer-container",
};

export const ADMIN = {
  loginForm: "admin-login-form",
  loginInput: "admin-login-input",
  loginSubmit: "admin-login-submit",
  loginError: "admin-login-error",
  dashboard: "admin-dashboard",
  logoutBtn: "admin-logout",
  exportBtn: "admin-export-csv",
  refreshBtn: "admin-refresh",
  filterStatus: "admin-filter-status",
  search: "admin-search",
  row: (id) => `admin-row-${id}`,
  statusSelect: (id) => `admin-status-${id}`,
  emptyState: "admin-empty",
  totalCount: "admin-total-count",
};
